export default class HashMenu {
	static init() {
		Array.prototype.forEach.call(document.querySelectorAll('.hash-menu__wrapper'), el => {
			new HashMenu(el);
		});
	}

	constructor(element) {
		if (!element) return;
		this.element = element;

		this.setTop();
		setTimeout(() => {
			// re-adjust after switch-language-notice was loaded
			this.setTop();
		}, 300);
		window.addEventListener('resize', () => this.setTop());

		const languageSwitcherNotice = document.querySelector('.switch-language-notice');
		if(languageSwitcherNotice) {
			// when the notice is beeing closed, we need to update the height
			languageSwitcherNotice.addEventListener('language-switcher-dismissed', () => this.setTop());
		}

		// detect when hash menu is sticky
		let prevY = 0;
		window.addEventListener('scroll', (e) => {
			const currentY = element.getBoundingClientRect().y;
			if (prevY !== currentY) {
				prevY = currentY;
				element.classList.remove('hash-menu__wrapper--is-sticky');
			} else {
				element.classList.add('hash-menu__wrapper--is-sticky');
			}
		});
	}

	setTop() {
		const headerHeight = document.querySelector('.header__inner')?.getBoundingClientRect().height ?? 0;
		const languageSwitcherNotice = document.querySelector('.body--switch-language-notice-is-visible .switch-language-notice');
		const languageSwitcherNoticeHeight = languageSwitcherNotice ? languageSwitcherNotice.getBoundingClientRect().height : 0;
		this.element.style.top = (languageSwitcherNoticeHeight + headerHeight + 24) + 'px';
	}
}
